module.exports = __webpack_public_path__ + "static/img/testimony (34).b1d09844.jpg";